// // // src/components/pediatric/AsthmaIndexTab.tsx
// // import React, { useEffect, useState } from "react";
// // import "../../css/AsthmaIndexTab.css";
// // import api from "../../api/axiosConfig";
// // // import { useParams } from "react-router-dom";
// // import { useParams, useNavigate } from "react-router-dom";
// // import { useAuth } from "../../context/AuthContext";

// // // A reusable component for each collapsible section
// // const AccordionSection: React.FC<{
// //   title: string;
// //   children: React.ReactNode;
// // }> = ({ title, children }) => {
// //   const [isOpen, setIsOpen] = useState(true);
// //   return (
// //     <div className={`accordion-section ${isOpen ? "open" : ""}`}>
// //       <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
// //         <h4>{title}</h4>
// //         <span className="accordion-chevron">&#9660;</span>
// //       </div>
// //       {isOpen && <div className="accordion-content">{children}</div>}
// //     </div>
// //   );
// // };

// // const AsthmaIndexTab: React.FC = () => {
// //   const navigate = useNavigate();
// //   const { emrNumber } = useParams<{ emrNumber: string }>();
// //   const { doctor } = useAuth();

// //   const [hasWheezing, setHasWheezing] = useState<boolean | null>(null);
// //   const [hasMoreThan3Episodes, setHasMoreThan3Episodes] = useState<
// //     boolean | null
// //   >(null);
// //   const [hasAsthmaParent, setHasAsthmaParent] = useState<boolean | null>(null);
// //   const [hasWheezingUnrelatedCold, setHasWheezingUnrelatedCold] = useState<
// //     boolean | null
// //   >(null);
// //   const [hasHighEosinophils, setHasHighEosinophils] = useState<boolean | null>(
// //     null,
// //   );
// //   const [atopicRisk, setAtopicRisk] = useState<boolean | null>(null);
// //   const [hasAeroAllergenSensitivity, setHasAeroAllergenSensitivity] = useState<
// //     boolean | null
// //   >(null);

// //   const [hasFoodAllergy, setHasFoodAllergy] = useState<boolean | null>(null);

// //   // const [protocolDecision, setProtocolDecision] = useState<"Yes" | "No" | null>(
// //   //   null,
// //   // );
// //   const [protocolDecision, setProtocolDecision] =
// // useState<"Yes" | "No" | "Undetermined" | null>(null);

// //   const [additionalNotes, setAdditionalNotes] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   useEffect(() => {
// //     const fetchHealthAnswers = async () => {
// //       if (!emrNumber) return;

// //       try {
// //         // 🔥 SINGLE API CALL
// //         const response = await api.Questionnair.get(
// //           `/api/answers/getans/${emrNumber}`,
// //           { params: { category: "health" } },
// //         );

// //         const answers = response?.data?.data?.[0]?.answers || [];

// //         // Helper function to extract only needed questionIds
// //         const getAnswer = (id: string) =>
// //           answers.find((a: any) => a.questionId === id)?.value === true;

// //         // ✅ Extract ONLY required IDs
// //         setHasWheezing(getAnswer("AM_10"));
// //         setHasMoreThan3Episodes(getAnswer("AM_11"));
// //         setHasAsthmaParent(getAnswer("AM_12"));
// //         setHasWheezingUnrelatedCold(getAnswer("AM_13"));
// //       } catch (error) {
// //         console.error("Failed to fetch asthma index answers", error);
// //         setHasWheezing(null);
// //         setHasMoreThan3Episodes(null);
// //         setHasAsthmaParent(null);
// //         setHasWheezingUnrelatedCold(null);
// //       }
// //     };

// //     fetchHealthAnswers();
// //   }, [emrNumber]);

// //   useEffect(() => {
// //     if (!emrNumber) return;
// //     // const labEmrId = "P-2026-000022-2"; // ✅ STATIC FOR TESTING

// //     const fetchLabReport = async () => {
// //       try {
// //         const labRes = await api.dataCollectionApi.get(
// //           `/api/forms/lab-report/${emrNumber}`,
// //         );

// //         const eosinophilsValue =
// //           labRes?.data?.data?.["Complete Blood Count (CBC)"]?.["Eosinophils"];

// //         if (typeof eosinophilsValue === "number") {
// //           setHasHighEosinophils(eosinophilsValue >= 4);
// //         } else {
// //           setHasHighEosinophils(null);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch lab report", error);
// //         setHasHighEosinophils(null);
// //       }
// //     };

// //     fetchLabReport();
// //   }, [emrNumber]);

// //   useEffect(() => {
// //     if (!emrNumber) return;
// //     // const scoringEmrId = "P-2026-000026-6"; // ✅ STATIC FOR TESTING

// //     const fetchAtopicRisk = async () => {
// //       try {
// //         const response = await api.Questionnair.get(
// //           `/api/scoring/scoresId/${emrNumber}/health`,
// //         );

// //         const scoreValue = response?.data?.data?.["1220"];

// //         if (scoreValue === true) {
// //           setAtopicRisk(true);
// //         } else if (scoreValue === false) {
// //           setAtopicRisk(false);
// //         } else {
// //           setAtopicRisk(null);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch Atopic Risk score", error);
// //         setAtopicRisk(null);
// //       }
// //     };

// //     fetchAtopicRisk();
// //   }, [emrNumber]);

// //   useEffect(() => {
// //     if (!emrNumber) return;
// //     // const patientId = "P-2026-000013-1"; // ✅ STATIC FOR TESTING

// //     const fetchAllergyAnswers = async () => {
// //       try {
// //         const response = await api.Questionnair.get(
// //           `/api/answers/getans/${emrNumber}`,
// //           { params: { category: "health" } },
// //         );

// //         const answers = response?.data?.data?.[0]?.answers || [];

// //         const getAnswer = (id: string) =>
// //           answers.find((a: any) => a.questionId === id)?.value;

// //         const aeroValue = getAnswer("CEBQ_01");
// //         const foodValue = getAnswer("CEBQ_02");

// //         setHasAeroAllergenSensitivity(
// //           typeof aeroValue === "boolean" ? aeroValue : null,
// //         );

// //         setHasFoodAllergy(typeof foodValue === "boolean" ? foodValue : null);
// //       } catch (error) {
// //         console.error("Failed to fetch allergy answers", error);
// //         setHasAeroAllergenSensitivity(null);
// //         setHasFoodAllergy(null);
// //       }
// //     };

// //     fetchAllergyAnswers();
// //   }, [emrNumber]);

// //   const isFormValid =
// //     protocolDecision !== null && additionalNotes.trim() !== "";

// // //   const handleSubmit = async (e?: React.MouseEvent<HTMLButtonElement>) => {
// // //     e?.preventDefault();
// // //     e?.stopPropagation();

// // //     if (!isFormValid) {
// // //       alert("Please select Yes/No and fill Additional Notes.");
// // //       return;
// // //     }

// // //     try {
// // //       setIsSubmitting(true);

// // //       const payload = {
// // //         emrId: emrNumber,
// // //         doctorName: doctor ? `Dr. ${doctor.name}` : null,
// // //         qualifying: {
// // //           experiencedWheezing: hasWheezing,
// // //           episodesLast12Months: hasMoreThan3Episodes,
// // //         },
// // //         majorCriteria: {
// // //           historyAsthmaInParent: hasAsthmaParent,
// // //           sensitivityToAeroallergens: hasAeroAllergenSensitivity,
// // //           riskOfAtopicDermatitis: atopicRisk,
// // //         },
// // //         minorCriteria: {
// // //           eosinophilsGte4Pct:
// // //             hasHighEosinophils === null
// // //               ? "not_provided"
// // //               : hasHighEosinophils
// // //                 ? // ? "Yes"
// // //                   // : "No",
// // //                   "selected"
// // //                 : "not_selected",
// // //           allergyToMilkEggPeanuts: hasFoodAllergy,
// // //           wheezingUnrelatedToCold: hasWheezingUnrelatedCold,
// // //         },
// // //         protocol: {
// // //           finalMapiScore: protocolDecision,
// // //           notes: additionalNotes,
// // //         },
// // //       };

// // //       await api.dataCollectionApi.post("/api/teledocs/mapi", payload);
// // // await api.CenterworkflowApi.post("/queues/complete", {
// // //    emrNumber,
// // //    queue: "PEDIATRIC_RESIDENT_Q"
// // // });
// // //       alert("mAPI saved successfully!");

// // //       setProtocolDecision(null);
// // //       setAdditionalNotes("");
// // //     } catch (error) {
// // //       console.error(error);
// // //       alert("Failed to save mAPI.");
// // //     } finally {
// // //       setIsSubmitting(false);
// // //     }
// // //   };




// // const handleSubmit = async (e?: React.MouseEvent<HTMLButtonElement>) => {
// //   e?.preventDefault();
// //   e?.stopPropagation();

// //   if (!isFormValid) {
// //     alert("Please select decision and fill Additional Notes.");
// //     return;
// //   }

// //   try {
// //     setIsSubmitting(true);

// //     // const payload = {
// //     //   emrId: emrNumber,
// //     //   doctorName: doctor ? `Dr. ${doctor.name}` : null,

// //     //   qualifying: {
// //     //     experiencedWheezing: hasWheezing,
// //     //     episodesLast12Months: hasMoreThan3Episodes,
// //     //   },

// //     //   majorCriteria: {
// //     //     historyAsthmaInParent: hasAsthmaParent,
// //     //     sensitivityToAeroallergens: hasAeroAllergenSensitivity,
// //     //     riskOfAtopicDermatitis: atopicRisk,
// //     //   },

// //     //   minorCriteria: {
// //     //     eosinophilsGte4Pct:
// //     //       hasHighEosinophils === null
// //     //         ? "not_provided"
// //     //         : hasHighEosinophils
// //     //         ? "selected"
// //     //         : "not_selected",

// //     //     allergyToMilkEggPeanuts: hasFoodAllergy,
// //     //     wheezingUnrelatedToCold: hasWheezingUnrelatedCold,
// //     //   },

// //     //   protocol: {
// //     //     finalMapiScore: protocolDecision,
// //     //     notes: additionalNotes,
// //     //   },
// //     // };




// //     const payload = {
// //   emrId: emrNumber,
// //   doctorName: doctor ? `Dr. ${doctor.name}` : null,

// //   protocol: {
// //     finalMapiScore:
// //       protocolDecision === "Undetermined"
// //         ? "No"
// //         : protocolDecision,

// //     manualDecision: protocolDecision,

// //     notes: additionalNotes,
// //   },
// // };

// //     await api.dataCollectionApi.post("/api/teledocs/mapi", payload);

// //     await api.CenterworkflowApi.post("/queues/PEDIATRIC_RESIDENT_Q", {
// //       emrNumber,
// //       queue: "PEDIATRIC_RESIDENT_Q",
// //     });

// //     alert("Pediatric Assessment Completed");

// //     navigate("/queue/pediatric");
// //   } catch (error) {
// //     console.error(error);
// //     alert("Failed to submit.");
// //   } finally {
// //     setIsSubmitting(false);
// //   }
// // };

// //   return (
// //     <div className="asthma-index-container">
// //       <AccordionSection title="Qualifying Criteria">
// //         <div className="criteria-item">
// //           <span>Has the child experienced wheezing?</span>
// //           {hasWheezing === null && <span className="value neutral">--</span>}
// //           {hasWheezing === true && (
// //             <span className="value positive">&#10003; Yes</span>
// //           )}
// //           {hasWheezing === false && (
// //             <span className="value negative">✗ No</span>
// //           )}
// //         </div>

// //         <div className="criteria-item">
// //           <span>Number of episodes in last 12 months</span>
// //           {hasMoreThan3Episodes === null && (
// //             <span className="value neutral">--</span>
// //           )}
// //           {hasMoreThan3Episodes === true && (
// //             <span className="value positive">&#10003; Yes</span>
// //           )}
// //           {hasMoreThan3Episodes === false && (
// //             <span className="value negative">✗ No</span>
// //           )}
// //         </div>
// //       </AccordionSection>

// //       <AccordionSection title="Major Criteria Checklist">
// //         <div className="checklist-grid">
// //           <div className="grid-header">CRITERIA</div>
// //           <div className="grid-header">VALUE</div>

// //           <div>History of asthma in parent</div>
// //           {hasAsthmaParent === null && <div className="value neutral">--</div>}
// //           {hasAsthmaParent === true && (
// //             <div className="value positive">✓ Yes</div>
// //           )}
// //           {hasAsthmaParent === false && (
// //             <div className="value negative">✗ No</div>
// //           )}

// //           <div>Sensitivity to aeroallergens</div>

// //           {hasAeroAllergenSensitivity === null && (
// //             <div className="value neutral">--</div>
// //           )}

// //           {hasAeroAllergenSensitivity === true && (
// //             <div className="value positive">✓ Yes</div>
// //           )}

// //           {hasAeroAllergenSensitivity === false && (
// //             <div className="value negative">✗ No</div>
// //           )}

// //           <div>Risk of Atopic Dermatitis (POIs &gt;20)</div>

// //           {atopicRisk === null && <div className="value neutral">Null</div>}

// //           {atopicRisk === true && (
// //             <div className="value positive">✓ Positive</div>
// //           )}

// //           {atopicRisk === false && (
// //             <div className="value negative">✗ Negative</div>
// //           )}
// //         </div>
// //       </AccordionSection>

// //       <AccordionSection title="Minor Criteria Checklist">
// //         <div className="checklist-grid">
// //           <div className="grid-header">CRITERIA</div>
// //           <div className="grid-header">VALUE</div>

// //           <div>Eosinophils ≥4%</div>
// //           {hasHighEosinophils === null && (
// //             <div className="value neutral">null</div>
// //           )}
// //           {hasHighEosinophils === true && (
// //             <div className="value positive">✓ Yes</div>
// //           )}
// //           {hasHighEosinophils === false && (
// //             <div className="value negative">✗ No</div>
// //           )}

// //           {/* <div>Allergy to milk, egg, peanuts</div>
// //           <div className="value negative">✗ Not Tested</div> */}

// //           <div>Allergy to milk, egg, peanuts</div>

// //           {hasFoodAllergy === null && <div className="value neutral">--</div>}

// //           {hasFoodAllergy === true && (
// //             <div className="value positive">✓ Yes</div>
// //           )}

// //           {hasFoodAllergy === false && (
// //             <div className="value negative">✗ No</div>
// //           )}

// //           <div>Wheezing episodes unrelated to cold</div>
// //           {hasWheezingUnrelatedCold === null && (
// //             <div className="value neutral">--</div>
// //           )}
// //           {hasWheezingUnrelatedCold === true && (
// //             <div className="value positive">✓ Yes</div>
// //           )}
// //           {hasWheezingUnrelatedCold === false && (
// //             <div className="value negative">✗ No</div>
// //           )}
// //         </div>
// //       </AccordionSection>

// //       <AccordionSection title="Protocol Rule Output">
// //         <div className="protocol-content">
// //           <p>
// //             IF the child has had 4 or more episodes of wheezing in the last 12
// //             months and fulfils either 1 Major Criteria OR 2 Minor Criteria, THEN
// //             score “Yes”, ELSE score “No”
// //           </p>
// // <label>
// //   <input
// //     type="radio"
// //     name="protocol"
// //     value="Undetermined"
// //     checked={protocolDecision === "Undetermined"}
// //     onChange={() => setProtocolDecision("Undetermined")}
// //   />
// //   Undetermined
// // </label>
// //           <div className="protocol-radios">
// //             <label>
// //               <input
// //                 type="radio"
// //                 name="protocol"
// //                 value="Yes"
// //                 checked={protocolDecision === "Yes"}
// //                 onChange={() => setProtocolDecision("Yes")}
// //               />
// //               Yes
// //             </label>

// //             <label>
// //               <input
// //                 type="radio"
// //                 name="protocol"
// //                 value="No"
// //                 checked={protocolDecision === "No"}
// //                 onChange={() => setProtocolDecision("No")}
// //               />
// //               No
// //             </label>
// //           </div>
// //         </div>
// //       </AccordionSection>

// //       {/* <div className="final-score-bar">
// //         {protocolDecision === null && (
// //           <span className="neutral">Final mAPI Score: --</span>
// //         )}

// //         {protocolDecision === "Yes" && (
// //           <span className="positive">✓ Final mAPI Score: Yes (Positive)</span>
// //         )}

// //         {protocolDecision === "No" && (
// //           <span className="negative">✗ Final mAPI Score: No (Negative)</span>
// //         )}
// //       </div> */}

// //       <div className="additional-notes-section">
// //         <h4>Additional Notes</h4>

// //         <textarea
// //           placeholder="Enter any additional observations or notes for the final report..."
// //           maxLength={500}
// //           value={additionalNotes}
// //           onChange={(e) => setAdditionalNotes(e.target.value)}
// //         />
// //       </div>

// //       <div className="footer-bar">
// //         <div className="progress-container">
// //           <div className="progress-bar">
// //             <div className="progress-fill" style={{ width: "75%" }} />
// //           </div>
// //           <span>3 of 4 steps completed</span>
// //         </div>
// //         <div className="action-buttons">
// //           {/* <button className="reset-btn">Reset</button> */}
// //           <button
// //             className="reset-btn"
// //             onClick={() => {
// //               setProtocolDecision(null);
// //               setAdditionalNotes("");
// //             }}
// //           >
// //             Reset
// //           </button>

// //           <button
// //             type="button"
// //             className="submit-btn"
// //             onClick={handleSubmit}
// //             // disabled={!isFormValid || isSubmitting}
// //             disabled={isSubmitting}
// //           >
// //             {isSubmitting ? "Submitting..." : "Submit"}
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AsthmaIndexTab;









// // // src/components/pediatric/AsthmaIndexTab.tsx

// // import React, { useEffect, useState } from "react";
// // import "../../css/AsthmaIndexTab.css";
// // import api from "../../api/axiosConfig";
// // import { useParams, useNavigate, useLocation } from "react-router-dom";
// // import { useAuth } from "../../context/AuthContext";

// // const AccordionSection: React.FC<{
// //   title: string;
// //   children: React.ReactNode;
// // }> = ({ title, children }) => {
// //   const [isOpen, setIsOpen] = useState(true);

// //   return (
// //     <div className={`accordion-section ${isOpen ? "open" : ""}`}>
// //       <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
// //         <h4>{title}</h4>
// //         <span className="accordion-chevron">&#9660;</span>
// //       </div>

// //       {isOpen && <div className="accordion-content">{children}</div>}
// //     </div>
// //   );
// // };

// // const AsthmaIndexTab: React.FC = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const sessionId = (location.state as any)?.sessionId;

// //   const { emrNumber } = useParams<{ emrNumber: string }>();
// //   const { doctor } = useAuth();

// //   const [hasWheezing, setHasWheezing] = useState<boolean | null>(null);
// //   const [hasMoreThan3Episodes, setHasMoreThan3Episodes] =
// //     useState<boolean | null>(null);

// //   const [hasAsthmaParent, setHasAsthmaParent] =
// //     useState<boolean | null>(null);

// //   const [hasWheezingUnrelatedCold, setHasWheezingUnrelatedCold] =
// //     useState<boolean | null>(null);

// //   const [hasHighEosinophils, setHasHighEosinophils] =
// //     useState<boolean | null>(null);

// //   const [atopicRisk, setAtopicRisk] = useState<boolean | null>(null);

// //   const [hasAeroAllergenSensitivity, setHasAeroAllergenSensitivity] =
// //     useState<boolean | null>(null);

// //   const [hasFoodAllergy, setHasFoodAllergy] =
// //     useState<boolean | null>(null);

// //   const [protocolDecision, setProtocolDecision] = useState<
// //     "Yes" | "No" | "Undetermined" | null
// //   >(null);

// //   const [additionalNotes, setAdditionalNotes] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   /* -------------------------------------------------- */
// //   /* Fetch Health Answers */
// //   /* -------------------------------------------------- */
// //   useEffect(() => {
// //     const fetchHealthAnswers = async () => {
// //       if (!emrNumber) return;

// //       try {
// //         const response = await api.Questionnair.get(
// //           `/api/answers/getans/${emrNumber}`,
// //           {
// //             params: { category: "health" },
// //           }
// //         );

// //         const answers = response?.data?.data?.[0]?.answers || [];

// //         const getAnswer = (id: string) =>
// //           answers.find((a: any) => a.questionId === id)?.value === true;

// //         setHasWheezing(getAnswer("AM_10"));
// //         setHasMoreThan3Episodes(getAnswer("AM_11"));
// //         setHasAsthmaParent(getAnswer("AM_12"));
// //         setHasWheezingUnrelatedCold(getAnswer("AM_13"));
// //       } catch (error) {
// //         console.error(error);
// //       }
// //     };

// //     fetchHealthAnswers();
// //   }, [emrNumber]);

// //   /* -------------------------------------------------- */
// //   /* Fetch Lab */
// //   /* -------------------------------------------------- */
// //   useEffect(() => {
// //     const fetchLab = async () => {
// //       if (!emrNumber) return;

// //       try {
// //         const res = await api.dataCollectionApi.get(
// //           `/api/forms/lab-report/${emrNumber}`
// //         );

// //         const eos =
// //           res?.data?.data?.["Complete Blood Count (CBC)"]?.[
// //             "Eosinophils"
// //           ];

// //         if (typeof eos === "number") {
// //           setHasHighEosinophils(eos >= 4);
// //         }
// //       } catch (error) {
// //         console.error(error);
// //       }
// //     };

// //     fetchLab();
// //   }, [emrNumber]);

// //   /* -------------------------------------------------- */
// //   /* Atopic Risk */
// //   /* -------------------------------------------------- */
// //   useEffect(() => {
// //     const fetchRisk = async () => {
// //       if (!emrNumber) return;

// //       try {
// //         const res = await api.Questionnair.get(
// //           `/api/scoring/scoresId/${emrNumber}/health`
// //         );

// //         const val = res?.data?.data?.["1220"];

// //         if (val === true) setAtopicRisk(true);
// //         else if (val === false) setAtopicRisk(false);
// //       } catch (error) {
// //         console.error(error);
// //       }
// //     };

// //     fetchRisk();
// //   }, [emrNumber]);

// //   /* -------------------------------------------------- */
// //   /* Allergy */
// //   /* -------------------------------------------------- */
// //   useEffect(() => {
// //     const fetchAllergy = async () => {
// //       if (!emrNumber) return;

// //       try {
// //         const response = await api.Questionnair.get(
// //           `/api/answers/getans/${emrNumber}`,
// //           {
// //             params: { category: "health" },
// //           }
// //         );

// //         const answers = response?.data?.data?.[0]?.answers || [];

// //         const getAnswer = (id: string) =>
// //           answers.find((a: any) => a.questionId === id)?.value;

// //         const aero = getAnswer("CEBQ_01");
// //         const food = getAnswer("CEBQ_02");

// //         setHasAeroAllergenSensitivity(
// //           typeof aero === "boolean" ? aero : null
// //         );

// //         setHasFoodAllergy(typeof food === "boolean" ? food : null);
// //       } catch (error) {
// //         console.error(error);
// //       }
// //     };

// //     fetchAllergy();
// //   }, [emrNumber]);

// //   const isFormValid =
// //     protocolDecision !== null &&
// //     additionalNotes.trim() !== "";

// //   /* -------------------------------------------------- */
// //   /* Submit */
// //   /* -------------------------------------------------- */
// //   const handleSubmit = async (
// //     e?: React.MouseEvent<HTMLButtonElement>
// //   ) => {
// //     e?.preventDefault();

// //     if (!isFormValid) {
// //       alert("Please select decision and fill notes.");
// //       return;
// //     }

// //     try {
// //       setIsSubmitting(true);

// //       const payload = {
// //         emrId: emrNumber,
// //         doctorName: doctor ? `Dr. ${doctor.name}` : null,

// //         qualifying: {
// //           experiencedWheezing: hasWheezing,
// //           episodesLast12Months: hasMoreThan3Episodes,
// //         },

// //         majorCriteria: {
// //           historyAsthmaInParent: hasAsthmaParent,
// //           sensitivityToAeroallergens:
// //             hasAeroAllergenSensitivity,
// //           riskOfAtopicDermatitis: atopicRisk,
// //         },

// //         minorCriteria: {
// //           eosinophilsGte4Pct:
// //             hasHighEosinophils === null
// //               ? "not_provided"
// //               : hasHighEosinophils
// //               ? "selected"
// //               : "not_selected",

// //           allergyToMilkEggPeanuts: hasFoodAllergy,
// //           wheezingUnrelatedToCold:
// //             hasWheezingUnrelatedCold,
// //         },

// //         protocol: {
// //           finalMapiScore:
// //             protocolDecision === "Undetermined"
// //               ? "No"
// //               : protocolDecision,

// //           manualDecision: protocolDecision,
// //           notes: additionalNotes,
// //         },
// //       };

// //       /* Save mAPI */
// //       await api.dataCollectionApi.post(
// //         "/api/teledocs/mapi",
// //         payload
// //       );

// //       /* Complete Pediatric Queue */
// //       if (sessionId) {
// //         await api.CenterworkflowApi.post(
// //           `/sessions/${sessionId}/tele-reporting/pediatric_resident/submit`,
// //           {
// //             remarks: additionalNotes || "done",
// //           }
// //         );
// //       }

// //       alert("Pediatric Assessment Completed");

// //       navigate("/queue/pediatric");
// //     } catch (error) {
// //       console.error(error);
// //       alert("Failed to submit.");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   return (
// //     <div className="asthma-index-container">
// //       {/* Qualifying */}
// //       <AccordionSection title="Qualifying Criteria">
// //         <div className="criteria-item">
// //           <span>Has the child experienced wheezing?</span>
// //           <span className="value">
// //             {hasWheezing === null
// //               ? "--"
// //               : hasWheezing
// //               ? "✓ Yes"
// //               : "✗ No"}
// //           </span>
// //         </div>

// //         <div className="criteria-item">
// //           <span>Number of episodes in last 12 months</span>
// //           <span className="value">
// //             {hasMoreThan3Episodes === null
// //               ? "--"
// //               : hasMoreThan3Episodes
// //               ? "✓ Yes"
// //               : "✗ No"}
// //           </span>
// //         </div>
// //       </AccordionSection>

// //       {/* Major */}
// //       <AccordionSection title="Major Criteria Checklist">
// //         <div className="checklist-grid">
// //           <div className="grid-header">CRITERIA</div>
// //           <div className="grid-header">VALUE</div>

// //           <div>History of asthma in parent</div>
// //           <div>{hasAsthmaParent ? "✓ Yes" : "--"}</div>

// //           <div>Sensitivity to aeroallergens</div>
// //           <div>
// //             {hasAeroAllergenSensitivity === null
// //               ? "--"
// //               : hasAeroAllergenSensitivity
// //               ? "✓ Yes"
// //               : "✗ No"}
// //           </div>

// //           <div>Risk of Atopic Dermatitis</div>
// //           <div>
// //             {atopicRisk === null
// //               ? "--"
// //               : atopicRisk
// //               ? "✓ Positive"
// //               : "✗ Negative"}
// //           </div>
// //         </div>
// //       </AccordionSection>

// //       {/* Minor */}
// //       <AccordionSection title="Minor Criteria Checklist">
// //         <div className="checklist-grid">
// //           <div className="grid-header">CRITERIA</div>
// //           <div className="grid-header">VALUE</div>

// //           <div>Eosinophils ≥4%</div>
// //           <div>
// //             {hasHighEosinophils === null
// //               ? "--"
// //               : hasHighEosinophils
// //               ? "✓ Yes"
// //               : "✗ No"}
// //           </div>

// //           <div>Allergy to milk, egg, peanuts</div>
// //           <div>
// //             {hasFoodAllergy === null
// //               ? "--"
// //               : hasFoodAllergy
// //               ? "✓ Yes"
// //               : "✗ No"}
// //           </div>

// //           <div>Wheezing unrelated to cold</div>
// //           <div>
// //             {hasWheezingUnrelatedCold === null
// //               ? "--"
// //               : hasWheezingUnrelatedCold
// //               ? "✓ Yes"
// //               : "✗ No"}
// //           </div>
// //         </div>
// //       </AccordionSection>

// //       {/* Protocol */}
// //       <AccordionSection title="Protocol Rule Output">
// //         <div className="protocol-content">
// //           <p>
// //           IF the child has had 4 or more episodes of wheezing in the last 12 months  
// // and fulfils either 1 Major Criteria OR 2 Minor Criteria,THEN score “Yes”, ELSE score “No” 
// //           </p>

// //           <div className="protocol-radios">
// //             <label>
// //               <input
// //                 type="radio"
// //                 checked={
// //                   protocolDecision === "Undetermined"
// //                 }
// //                 onChange={() =>
// //                   setProtocolDecision(
// //                     "Undetermined"
// //                   )
// //                 }
// //               />
// //               Undetermined
// //             </label>

// //             <label>
// //               <input
// //                 type="radio"
// //                 checked={protocolDecision === "Yes"}
// //                 onChange={() =>
// //                   setProtocolDecision("Yes")
// //                 }
// //               />
// //               Yes
// //             </label>

// //             <label>
// //               <input
// //                 type="radio"
// //                 checked={protocolDecision === "No"}
// //                 onChange={() =>
// //                   setProtocolDecision("No")
// //                 }
// //               />
// //               No
// //             </label>
// //           </div>
// //         </div>
// //       </AccordionSection>

// //       {/* Notes */}
// //       <div className="additional-notes-section">
// //         <h4>Additional Notes</h4>

// //         <textarea
// //           value={additionalNotes}
// //           onChange={(e) =>
// //             setAdditionalNotes(e.target.value)
// //           }
// //           placeholder="Enter notes..."
// //         />
// //       </div>

// //       {/* Footer */}
// //       <div className="footer-bar">
// //         <div className="progress-container">
// //           <div className="progress-bar">
// //             <div
// //               className="progress-fill"
// //               style={{ width: "100%" }}
// //             />
// //           </div>

// //           <span>Completed</span>
// //         </div>

// //         <div className="action-buttons">
// //           <button
// //             className="reset-btn"
// //             onClick={() => {
// //               setProtocolDecision(null);
// //               setAdditionalNotes("");
// //             }}
// //           >
// //             Reset
// //           </button>

// //           <button
// //             className="submit-btn"
// //             disabled={isSubmitting}
// //             onClick={handleSubmit}
// //           >
// //             {isSubmitting
// //               ? "Submitting..."
// //               : "Submit"}
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AsthmaIndexTab;



// // src/components/pediatric/AsthmaIndexTab.tsx

// import React, { useEffect, useState } from "react";
// import "../../css/AsthmaIndexTab.css";
// import api from "../../api/axiosConfig";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";

// const AccordionSection: React.FC<{
//   title: string;
//   children: React.ReactNode;
// }> = ({ title, children }) => {
//   const [isOpen, setIsOpen] = useState(true);

//   return (
//     <div className={`accordion-section ${isOpen ? "open" : ""}`}>
//       <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
//         <h4>{title}</h4>
//         <span className="accordion-chevron">&#9660;</span>
//       </div>

//       {isOpen && <div className="accordion-content">{children}</div>}
//     </div>
//   );
// };

// const AsthmaIndexTab: React.FC = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const sessionId = (location.state as any)?.sessionId;

//   const { emrNumber } = useParams<{ emrNumber: string }>();
//   const { doctor } = useAuth();

//   const [hasWheezing, setHasWheezing] = useState<boolean | null>(null);
//   const [hasMoreThan3Episodes, setHasMoreThan3Episodes] = useState<boolean | null>(null);
//   const [hasAsthmaParent, setHasAsthmaParent] = useState<boolean | null>(null);
//   const [hasWheezingUnrelatedCold, setHasWheezingUnrelatedCold] = useState<boolean | null>(null);
//   const [hasHighEosinophils, setHasHighEosinophils] = useState<boolean | null>(null);
//   const [atopicRisk, setAtopicRisk] = useState<boolean | null>(null);
//   const [hasAeroAllergenSensitivity, setHasAeroAllergenSensitivity] = useState<boolean | null>(null);
//   const [hasFoodAllergy, setHasFoodAllergy] = useState<boolean | null>(null);

//   const [protocolDecision, setProtocolDecision] = useState<
//     "Yes" | "No" | "Undetermined" | null
//   >(null);

//   const [additionalNotes, setAdditionalNotes] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   /* -------------------------------------------------- */
//   /* Fetch ALL Health Answers & Risk Scores (Combined)  */
//   /* -------------------------------------------------- */
//   useEffect(() => {
//     const fetchQuestionnaireData = async () => {
//       if (!emrNumber) return;

//       try {
//         // 1. Fetch the raw answers for the specific questions
//         // 🔥 FIX: Changed to dataCollectionApi and added /questionnair prefix
//         const ansRes = await api.Questionnair.get(
//           `/api/answers/getans/${emrNumber}`,
//           { params: { category: "health" } }
//         );

//         const answers = ansRes?.data?.data?.[0]?.answers || [];

//         // Helper to safely check if an answer is true or "Yes"
//         const checkYes = (id: string) => {
//           const val = answers.find((a: any) => a.questionId === id)?.value;
//           if (val === true || String(val).toLowerCase() === "yes") return true;
//           if (val === false || String(val).toLowerCase() === "no") return false;
//           return null; // Return null if unanswered so it shows "--"
//         };

//         setHasWheezing(checkYes("AM_10"));
//         setHasMoreThan3Episodes(checkYes("AM_11"));
//         setHasAsthmaParent(checkYes("AM_12"));
//         setHasWheezingUnrelatedCold(checkYes("AM_13"));
//         setHasAeroAllergenSensitivity(checkYes("AM_14"));
//         setHasFoodAllergy(checkYes("AM_15"));

//         // 2. Fetch the Atopic Dermatitis Risk score
//         const scoreRes = await api.Questionnair.get(
//           `/api/scoring/scoresId/${emrNumber}/health`
//         );

//         const atopicScore = 
//           scoreRes?.data?.scores?.resultsById?.["1220"] || 
//           scoreRes?.data?.data?.["1220"];

//         if (atopicScore === true || String(atopicScore).toLowerCase() === "yes") {
//           setAtopicRisk(true);
//         } else if (atopicScore === false || String(atopicScore).toLowerCase() === "no") {
//           setAtopicRisk(false);
//         }

//       } catch (error) {
//         console.error("Failed to fetch questionnaire data:", error);
//       }
//     };

//     fetchQuestionnaireData();
//   }, [emrNumber]);

//   /* -------------------------------------------------- */
//   /* Fetch Lab Report (Eosinophils)                     */
//   /* -------------------------------------------------- */
//   useEffect(() => {
//     const fetchLab = async () => {
//       if (!emrNumber) return;

//       try {
//         const res = await api.dataCollectionApi.get(
//           `/api/forms/lab-report/${emrNumber}`
//         );

//         const eos = res?.data?.data?.["Complete Blood Count (CBC)"]?.["Eosinophils"];

//         if (typeof eos === "number") {
//           setHasHighEosinophils(eos >= 4);
//         }
//       } catch (error) {
//         console.error("Failed to fetch lab data:", error);
//       }
//     };

//     fetchLab();
//   }, [emrNumber]);

//   const isFormValid = protocolDecision !== null && additionalNotes.trim() !== "";

//   /* -------------------------------------------------- */
//   /* Submit Logic                                       */
//   /* -------------------------------------------------- */
//   const handleSubmit = async (e?: React.MouseEvent<HTMLButtonElement>) => {
//     e?.preventDefault();

//     if (!isFormValid) {
//       alert("Please select decision and fill notes.");
//       return;
//     }

//     try {
//       setIsSubmitting(true);

//       const payload = {
//         emrId: emrNumber,
//         doctorName: doctor ? `Dr. ${doctor.name}` : null,

//         qualifying: {
//           experiencedWheezing: hasWheezing,
//           episodesLast12Months: hasMoreThan3Episodes,
//         },

//         majorCriteria: {
//           historyAsthmaInParent: hasAsthmaParent,
//           sensitivityToAeroallergens: hasAeroAllergenSensitivity,
//           riskOfAtopicDermatitis: atopicRisk,
//         },

//         minorCriteria: {
//           eosinophilsGte4Pct:
//             hasHighEosinophils === null
//               ? "not_provided"
//               : hasHighEosinophils
//               ? "selected"
//               : "not_selected",

//           allergyToMilkEggPeanuts: hasFoodAllergy,
//           wheezingUnrelatedToCold: hasWheezingUnrelatedCold,
//         },

//         protocol: {
//           finalMapiScore: protocolDecision === "Undetermined" ? "No" : protocolDecision,
//           manualDecision: protocolDecision,
//           notes: additionalNotes,
//         },
//       };

//       /* Save mAPI */
//       await api.dataCollectionApi.post("/api/teledocs/mapi", payload);

//       /* Complete Pediatric Queue */
//       if (sessionId) {
//         await api.CenterworkflowApi.post(
//           `/sessions/${sessionId}/tele-reporting/pediatric_resident/submit`,
//           {
//             remarks: additionalNotes || "done",
//           }
//         );
//       }

//       alert("Pediatric Assessment Completed");
//       navigate("/queue/pediatric");
//     } catch (error) {
//       console.error(error);
//       alert("Failed to submit.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="asthma-index-container">
//       {/* Qualifying */}
//       <AccordionSection title="Qualifying Criteria">
//         <div className="criteria-item">
//           <span>Has the child experienced wheezing?</span>
//           <span className="value">
//             {hasWheezing === null ? "--" : hasWheezing ? "✓ Yes" : "✗ No"}
//           </span>
//         </div>

//         <div className="criteria-item">
//           <span>Has your child had more than 4 episodes of wheezing in the last 12 months?</span>
//           <span className="value">
//             {hasMoreThan3Episodes === null ? "--" : hasMoreThan3Episodes ? "✓ Yes" : "✗ No"}
//           </span>
//         </div>
//       </AccordionSection>

//       {/* Major */}
//       <AccordionSection title="Major Criteria Checklist">
//         <div className="checklist-grid">
//           <div className="grid-header">CRITERIA</div>
//           <div className="grid-header">VALUE</div>

//           <div>History of asthma in parent</div>
//           <div>{hasAsthmaParent === null ? "--" : hasAsthmaParent ? "✓ Yes" : "✗ No"}</div>

//           <div>Sensitivity to aeroallergens</div>
//           <div>
//             {hasAeroAllergenSensitivity === null ? "--" : hasAeroAllergenSensitivity ? "✓ Yes" : "✗ No"}
//           </div>

//           <div>Risk of Atopic Dermatitis</div>
//           <div>
//             {atopicRisk === null ? "--" : atopicRisk ? "✓ Positive" : "✗ Negative"}
//           </div>
//         </div>
//       </AccordionSection>

//       {/* Minor */}
//       <AccordionSection title="Minor Criteria Checklist">
//         <div className="checklist-grid">
//           <div className="grid-header">CRITERIA</div>
//           <div className="grid-header">VALUE</div>

//           <div>Eosinophils ≥4%</div>
//           <div>
//             {hasHighEosinophils === null ? "--" : hasHighEosinophils ? "✓ Yes" : "✗ No"}
//           </div>

//           <div>Allergy to milk, egg, peanuts</div>
//           <div>
//             {hasFoodAllergy === null ? "--" : hasFoodAllergy ? "✓ Yes" : "✗ No"}
//           </div>

//           <div>Wheezing unrelated to cold</div>
//           <div>
//             {hasWheezingUnrelatedCold === null ? "--" : hasWheezingUnrelatedCold ? "✓ Yes" : "✗ No"}
//           </div>
//         </div>
//       </AccordionSection>

//       {/* Protocol */}
//       <AccordionSection title="Protocol Rule Output">
//         <div className="protocol-content">
//           <p>
//             IF the child has had 4 or more episodes of wheezing in the last 12 months  
//             and fulfils either 1 Major Criteria OR 2 Minor Criteria, THEN score “Yes”, ELSE score “No” 
//           </p>

//           <div className="protocol-radios">
//             <label>
//               <input
//                 type="radio"
//                 checked={protocolDecision === "Undetermined"}
//                 onChange={() => setProtocolDecision("Undetermined")}
//               />
//               Undetermined
//             </label>

//             <label>
//               <input
//                 type="radio"
//                 checked={protocolDecision === "Yes"}
//                 onChange={() => setProtocolDecision("Yes")}
//               />
//               Yes
//             </label>

//             <label>
//               <input
//                 type="radio"
//                 checked={protocolDecision === "No"}
//                 onChange={() => setProtocolDecision("No")}
//               />
//               No
//             </label>
//           </div>
//         </div>
//       </AccordionSection>

//       {/* Notes */}
//       <div className="additional-notes-section">
//         <h4>Additional Notes</h4>
//         <textarea
//           value={additionalNotes}
//           onChange={(e) => setAdditionalNotes(e.target.value)}
//           placeholder="Enter notes..."
//         />
//       </div>

//       {/* Footer */}
//       <div className="footer-bar">
//         <div className="progress-container">
//           <div className="progress-bar">
//             <div className="progress-fill" style={{ width: "100%" }} />
//           </div>
//           <span>Completed</span>
//         </div>

//         <div className="action-buttons">
//           <button
//             className="reset-btn"
//             onClick={() => {
//               setProtocolDecision(null);
//               setAdditionalNotes("");
//             }}
//           >
//             Reset
//           </button>

//           <button
//             className="submit-btn"
//             disabled={isSubmitting}
//             onClick={handleSubmit}
//           >
//             {isSubmitting ? "Submitting..." : "Submit"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AsthmaIndexTab;




import React, { useEffect, useState } from "react";
import "../../css/AsthmaIndexTab.css";
import api from "../../api/axiosConfig";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AccordionSection: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`accordion-section ${isOpen ? "open" : ""}`}>
      <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
        <h4>{title}</h4>
        <span className="accordion-chevron">&#9660;</span>
      </div>

      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
};

const AsthmaIndexTab: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const sessionId = (location.state as any)?.sessionId;

  const { emrNumber } = useParams<{ emrNumber: string }>();
  const { doctor, currentUser } = useAuth();

  const [hasWheezing, setHasWheezing] = useState<boolean | null>(null);
  const [hasMoreThan3Episodes, setHasMoreThan3Episodes] = useState<boolean | null>(null);
  const [hasAsthmaParent, setHasAsthmaParent] = useState<boolean | null>(null);
  const [hasWheezingUnrelatedCold, setHasWheezingUnrelatedCold] = useState<boolean | null>(null);
  const [hasHighEosinophils, setHasHighEosinophils] = useState<boolean | null>(null);
  const [atopicRisk, setAtopicRisk] = useState<boolean | null>(null);
  const [hasAeroAllergenSensitivity, setHasAeroAllergenSensitivity] = useState<boolean | null>(null);
  const [hasFoodAllergy, setHasFoodAllergy] = useState<boolean | null>(null);

  const [protocolDecision, setProtocolDecision] = useState<
    "Yes" | "No" | "Undetermined" | null
  >(null);

  const [additionalNotes, setAdditionalNotes] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  /* -------------------------------------------------- */
  /* Fetch ALL Health Answers & Risk Scores (Combined)  */
  /* -------------------------------------------------- */
  useEffect(() => {
    const fetchQuestionnaireData = async () => {
      if (!emrNumber) return;

      try {
        const ansRes = await api.Questionnair.get(
          `/api/answers/getans/${emrNumber}`,
          { params: { category: "health" } }
        );

        const answers = ansRes?.data?.data?.[0]?.answers || [];

        const checkYes = (id: string) => {
          const val = answers.find((a: any) => a.questionId === id)?.value;
          if (val === true || String(val).toLowerCase() === "yes") return true;
          if (val === false || String(val).toLowerCase() === "no") return false;
          return null; // Return null if unanswered so it shows "--"
        };

        setHasWheezing(checkYes("AM_10"));
        setHasMoreThan3Episodes(checkYes("AM_11"));
        setHasAsthmaParent(checkYes("AM_12"));
        setHasWheezingUnrelatedCold(checkYes("AM_13"));
        setHasAeroAllergenSensitivity(checkYes("AM_14"));
        setHasFoodAllergy(checkYes("AM_15"));

        const scoreRes = await api.Questionnair.get(
          `/api/scoring/scoresId/${emrNumber}/health`
        );

        const atopicScore = 
          scoreRes?.data?.scores?.resultsById?.["1220"] || 
          scoreRes?.data?.data?.["1220"];

        if (atopicScore === true || String(atopicScore).toLowerCase() === "yes") {
          setAtopicRisk(true);
        } else if (atopicScore === false || String(atopicScore).toLowerCase() === "no") {
          setAtopicRisk(false);
        }

      } catch (error) {
        console.error("Failed to fetch questionnaire data:", error);
      }
    };

    fetchQuestionnaireData();
  }, [emrNumber]);

  /* -------------------------------------------------- */
  /* Fetch Lab Report (Eosinophils)                     */
  /* -------------------------------------------------- */
  useEffect(() => {
    const fetchLab = async () => {
      if (!emrNumber) return;

      try {
        const res = await api.dataCollectionApi.get(
          `/api/forms/lab-report/${emrNumber}`
        );

        const eos = res?.data?.data?.["Complete Blood Count (CBC)"]?.["Eosinophils"];

        if (typeof eos === "number") {
          setHasHighEosinophils(eos >= 4);
        }
      } catch (error) {
        console.error("Failed to fetch lab data:", error);
      }
    };

    fetchLab();
  }, [emrNumber]);

  const isFormValid = protocolDecision !== null && additionalNotes.trim() !== "";

  /* -------------------------------------------------- */
  /* Submit Logic                                       */
  /* -------------------------------------------------- */
  const handleSubmit = async (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();

    if (!isFormValid) {
      alert("Please select decision and fill notes.");
      return;
    }

    try {
      setIsSubmitting(true);

      const payload = {
        emrId: emrNumber,
        doctorName: doctor ? `Dr. ${doctor.name}` : null,

        qualifying: {
          experiencedWheezing: hasWheezing,
          episodesLast12Months: hasMoreThan3Episodes,
        },

        majorCriteria: {
          historyAsthmaInParent: hasAsthmaParent,
          sensitivityToAeroallergens: hasAeroAllergenSensitivity,
          riskOfAtopicDermatitis: atopicRisk,
        },

        minorCriteria: {
          eosinophilsGte4Pct:
            hasHighEosinophils === null
              ? "not_provided"
              : hasHighEosinophils
              ? "selected"
              : "not_selected",

          allergyToMilkEggPeanuts: hasFoodAllergy,
          wheezingUnrelatedToCold: hasWheezingUnrelatedCold,
        },

        protocol: {
          finalMapiScore: protocolDecision === "Undetermined" ? "No" : protocolDecision,
          manualDecision: protocolDecision,
          notes: additionalNotes,
        },
      };

      /* Save mAPI */
      await api.dataCollectionApi.post("/api/teledocs/mapi", payload);

      /* Complete Pediatric Queue */
      if (sessionId) {
        const doctorId = currentUser?.user?._id;

        if (!doctorId) {
          console.error("Doctor ID is missing from currentUser:", currentUser);
          alert("Doctor ID missing. Please login again.");
          return;
        }

        await api.CenterworkflowApi.post(
          `/sessions/${sessionId}/tele-reporting/pediatric_resident/submit`,
          {
            doctorId,
            remarks: additionalNotes || "done",
          }
        );
      }

      alert("Pediatric Assessment Completed");
      navigate("/queue/pediatric");
    } catch (error) {
      console.error(error);
      alert("Failed to submit.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="asthma-index-container">
      {/* Qualifying */}
      <AccordionSection title="Qualifying Criteria">
        <div className="criteria-item">
          <span>Has the child experienced wheezing?</span>
          <span className="value">
            {hasWheezing === null ? "--" : hasWheezing ? "✓ Yes" : "✗ No"}
          </span>
        </div>

        <div className="criteria-item">
          <span>Has your child had more than 4 episodes of wheezing in the last 12 months?</span>
          <span className="value">
            {hasMoreThan3Episodes === null ? "--" : hasMoreThan3Episodes ? "✓ Yes" : "✗ No"}
          </span>
        </div>
      </AccordionSection>

      {/* Major */}
      <AccordionSection title="Major Criteria Checklist">
        <div className="checklist-grid">
          <div className="grid-header">CRITERIA</div>
          <div className="grid-header">VALUE</div>

          <div>History of asthma in parent</div>
          <div>{hasAsthmaParent === null ? "--" : hasAsthmaParent ? "✓ Yes" : "✗ No"}</div>

          <div>Sensitivity to aeroallergens</div>
          <div>
            {hasAeroAllergenSensitivity === null ? "--" : hasAeroAllergenSensitivity ? "✓ Yes" : "✗ No"}
          </div>

          <div>Risk of Atopic Dermatitis</div>
          <div>
            {atopicRisk === null ? "--" : atopicRisk ? "✓ Positive" : "✗ Negative"}
          </div>
        </div>
      </AccordionSection>

      {/* Minor */}
      <AccordionSection title="Minor Criteria Checklist">
        <div className="checklist-grid">
          <div className="grid-header">CRITERIA</div>
          <div className="grid-header">VALUE</div>

          <div>Eosinophils ≥4%</div>
          <div>
            {hasHighEosinophils === null ? "--" : hasHighEosinophils ? "✓ Yes" : "✗ No"}
          </div>

          <div>Allergy to milk, egg, peanuts</div>
          <div>
            {hasFoodAllergy === null ? "--" : hasFoodAllergy ? "✓ Yes" : "✗ No"}
          </div>

          <div>Wheezing unrelated to cold</div>
          <div>
            {hasWheezingUnrelatedCold === null ? "--" : hasWheezingUnrelatedCold ? "✓ Yes" : "✗ No"}
          </div>
        </div>
      </AccordionSection>

      {/* Protocol */}
      <AccordionSection title="Protocol Rule Output">
        <div className="protocol-content">
          <p>
            IF the child has had 4 or more episodes of wheezing in the last 12 months  
            and fulfils either 1 Major Criteria OR 2 Minor Criteria, THEN score “Yes”, ELSE score “No” 
          </p>

          <div className="protocol-radios">
            <label>
              <input
                type="radio"
                checked={protocolDecision === "Undetermined"}
                onChange={() => setProtocolDecision("Undetermined")}
              />
              Undetermined
            </label>

            <label>
              <input
                type="radio"
                checked={protocolDecision === "Yes"}
                onChange={() => setProtocolDecision("Yes")}
              />
              Yes
            </label>

            <label>
              <input
                type="radio"
                checked={protocolDecision === "No"}
                onChange={() => setProtocolDecision("No")}
              />
              No
            </label>
          </div>
        </div>
      </AccordionSection>

      {/* Notes */}
      <div className="additional-notes-section">
        <h4>Additional Notes</h4>
        <textarea
          value={additionalNotes}
          onChange={(e) => setAdditionalNotes(e.target.value)}
          placeholder="Enter notes..."
        />
      </div>

      {/* Footer */}
      <div className="footer-bar">
        <div className="progress-container">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: "100%" }} />
          </div>
          <span>Completed</span>
        </div>

        <div className="action-buttons">
          <button
            className="reset-btn"
            onClick={() => {
              setProtocolDecision(null);
              setAdditionalNotes("");
            }}
          >
            Reset
          </button>

          <button
            className="submit-btn"
            disabled={isSubmitting}
            onClick={handleSubmit}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AsthmaIndexTab;
